import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Payments() {
  return (
    <PageLayout
      title="Omnichannel Payments"
      subtitle="Accept online, mobile, and contactless in-person payments seamlessly across all platforms."
      badge="CORE PRODUCT"
      imageSrc="/products/art_payments_1776905062448.png"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center mb-6">
            <i className="ri-global-line text-2xl"></i>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Online Checkout</h3>
          <p className="text-gray-600">High-converting hosted payment pages and drop-in UI components designed to minimize cart abandonment.</p>
        </div>
        
        <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-xl flex items-center justify-center mb-6">
            <i className="ri-smartphone-line text-2xl"></i>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Mobile SDKs</h3>
          <p className="text-gray-600">Integrate deeply native payment flows into your iOS and Android applications with just a few lines of code.</p>
        </div>
        
        <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 bg-green-50 text-green-600 rounded-xl flex items-center justify-center mb-6">
            <i className="ri-wifi-line text-2xl"></i>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Tap to Pay</h3>
          <p className="text-gray-600">Turn any compatible smartphone into a secure SoftPOS terminal. Zero extra hardware required.</p>
        </div>
      </div>
    </PageLayout>
  );
}
